import { render, staticRenderFns } from "./ProductosList.vue?vue&type=template&id=fd0d5584&"
import script from "./ProductosList.vue?vue&type=script&lang=js&"
export * from "./ProductosList.vue?vue&type=script&lang=js&"
import style0 from "./ProductosList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports